module.exports = __webpack_public_path__ + "static/skills_site-b279d18acfd655aefa9af134500c9a63.jpg";